import { IntegrityMonitorRulesGridController } from '../controller/IntegrityMonitorRulesGridController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { ViewConfiguration } from '../../../../grid/gridView/types';
import { Column, ColumnKeys } from '../types';
import { ViewType } from '../../integrityMonitorRulesSmartViews/types';
import { GridColumnConfiguration } from '@nirvana/shared/dtos/types/shared/grid';

export class IntegrityMonitorRulesGridWebComponent extends BaseWebComponentElement {
  public controller: IntegrityMonitorRulesGridController;
  private _currentView: ViewConfiguration<Column, ColumnKeys, ViewType>;
  private ruleIdsFilterRef: Array<string> = [];
  private canFetchRulesCountInRuleSetRef = false;
  private rulesCountInRuleSetRef: number | null = null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrityMonitorRulesGridController,
    });
  }

  public refreshGrid(): void {
    this.controller.view.dom.$gridView.controller.handleGridItemsLoad(true);
  }

  get currentView(): ViewConfiguration<Column, ColumnKeys, ViewType> {
    return this._currentView;
  }

  set currentView(value: ViewConfiguration<Column, ColumnKeys, ViewType>) {
    this._currentView = value;
  }

  get ruleIdsFilter(): Array<string> {
    return this.ruleIdsFilterRef;
  }

  set ruleIdsFilter(value: Array<string>) {
    this.ruleIdsFilterRef = value;
  }

  get isCompactViewChecked(): boolean {
    return this.controller.view.dom.$gridView.isCompactViewChecked;
  }

  set isCompactViewChecked(value: boolean) {
    this.controller.view.dom.$gridView.isCompactViewChecked = value;
  }

  get pageSize(): number {
    return this.controller.view.dom.$gridView.pageSize;
  }

  set pageSize(value: number) {
    this.controller.view.dom.$gridView.pageSize = value;
  }

  get columnConfigs(): Array<GridColumnConfiguration> {
    return this.controller.view.dom.$gridView.columnConfigs;
  }

  set columnConfigs(value: Array<GridColumnConfiguration>) {
    this.controller.view.dom.$gridView.columnConfigs = value;
  }

  get columns(): Array<Column> {
    return this.controller.view.dom.$gridView.columns;
  }

  set columns(value: Array<Column>) {
    this.controller.view.dom.$gridView.columns = value;
  }

  get canFetchRulesCountInRuleSet(): boolean {
    return this.canFetchRulesCountInRuleSetRef;
  }

  set canFetchRulesCountInRuleSet(value: boolean) {
    this.canFetchRulesCountInRuleSetRef = value;
  }

  get rulesCountInRuleSet(): number | null {
    return this.rulesCountInRuleSetRef;
  }

  set rulesCountInRuleSet(value: number | null) {
    this.rulesCountInRuleSetRef = value;
  }
}
